import React, { Component } from 'react';

function reloadPage() {
  if (typeof window !== 'undefined') {
    window.location.reload();
  }
}

class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(previousProps) {
    const { resetKey } = this.props;
    const { error } = this.state;

    if (error && previousProps.resetKey !== resetKey) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unable to render the requested route:', error, errorInfo);
  }

  render() {
    const { children, onReload = reloadPage } = this.props;
    const { error } = this.state;

    if (!error) {
      return children;
    }

    return (
      <section
        aria-labelledby="route-error-title"
        className="route-message route-error"
        role="alert"
      >
        <p className="route-message__eyebrow">Navigation error</p>
        <h1 id="route-error-title">This page could not be loaded.</h1>
        <p>
          A new version may be available, or the connection may have been
          interrupted.
        </p>
        <button
          className="route-error__action"
          onClick={onReload}
          type="button"
        >
          Reload page
        </button>
      </section>
    );
  }
}

export default RouteErrorBoundary;
